import cache from "../../cache";
import axios from 'axios';
import {
  FETCHING_BLOGS,
  FETCHING_BLOGS_FAILED,
  FETCHING_BLOGS_SUCCESSFUL,
  FETCHING_POPULAR_BLOGS,
  FETCHING_POPULAR_BLOGS_FAILED,
  FETCHING_POPULAR_BLOGS_SUCCESSFUL,
  FETCHING_FEATURED_BLOGS,
  FETCHING_FEATURED_BLOGS_FAILED,
  FETCHING_FEATURED_BLOGS_SUCCESSFUL,
  FETCHING_SINGLE_BLOG,
  FETCHING_SINGLE_BLOG_COMPLETE,
  FILTERED_BLOG_TYPE,

  ADDING_BLOGS,
  ADDING_BLOGS_FAILED,
  ADDING_BLOGS_SUCCESS,
} from "./types";
import {
  fetchBlogsByFilterService,
  fetchFeaturedBlogsService,
  fetchBlogService,
  fetchSingleBlogsService,
  fetchPopularBlogService,
  createBlogService,
} from "./api";
import { toast } from "react-toastify";

export const fetchBlogsAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_BLOGS });
    const response = await fetchBlogService(params);
    const {
      data: { stories },
      headers: { total, per_page },
    } = response;
    dispatch({
      type: FETCHING_BLOGS_SUCCESSFUL,
      blogs: {
        data: stories,
        total,
        per_page,
      },
    });
  } catch (error) {
    dispatch({ type: FETCHING_BLOGS_FAILED });
  }
};

export const fetchBlogsActionAdmin = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_BLOGS });
    const response = await fetchBlogService(params)();
    dispatch({ type: FETCHING_BLOGS_SUCCESSFUL, blogs: response?.data });
  } catch (error) {
    dispatch({ type: FETCHING_BLOGS_FAILED });
  }
};

export const fetchRandomBlogAction = (params) => async (dispatch) => {
  try {
    const response = await fetchBlogService(params);
    return response?.data.stories;
  } catch (error) {}
};

export const fetchPopularBlogAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_POPULAR_BLOGS });
    const response = await fetchPopularBlogService(params)();
    dispatch({
      type: FETCHING_POPULAR_BLOGS_SUCCESSFUL,
      blogs: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCHING_POPULAR_BLOGS_FAILED });
  }
};

export const fetchFilteredBlog =
  (fType = "popular") =>
  async (dispatch) => {
    const type = FILTERED_BLOG_TYPE[fType] || FILTERED_BLOG_TYPE.popular;
    try {
      dispatch({ type: type.data });
      const cacheKey = "featuredBlogs";
      let cachedBlogs = cache.get(cacheKey);
      // will use cache data pending when server request has been resolved.
      dispatch({ type: type.success, payload: cachedBlogs || [] });

      const response = await fetchBlogsByFilterService(type);
      const blogs = response?.data;
      cache.set(cacheKey, blogs);
      // once server has resolved data successfully, we update the cache data and return the servers data.
      dispatch({ type: type.success, payload: blogs });
    } catch (error) {
      dispatch({ type: type.failed, payload: error.message });
    }
  };

export const fetchSingleBlog = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_SINGLE_BLOG });
    const response = await fetchSingleBlogsService(id);
    dispatch({ type: FETCHING_SINGLE_BLOG_COMPLETE });
    return response?.data?.story;
  } catch (error) {
    dispatch({ type: FETCHING_SINGLE_BLOG_COMPLETE });
  }
};

export const fetchFeaturedBlogAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_FEATURED_BLOGS });
    const response = await fetchFeaturedBlogsService(params)();
    dispatch({
      type: FETCHING_FEATURED_BLOGS_SUCCESSFUL,
      blog: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCHING_FEATURED_BLOGS_FAILED });
  }
};

export const addBlogAction = ({token, params}) => async (dispatch) => {
  try {

    dispatch({type: ADDING_BLOGS})
    let thumbnailDetails;
    if (params?.thumbnail) {
      const formData = new FormData();
      formData.append("file", params?.thumbnail);
      formData.append(
        "upload_preset",
        process.env.REACT_APP_CLOUDINARY_UNSIGNED_PRESET
      );
      formData.append("options", { quality: 5 })
      const response = await axios.post(
        process.env.REACT_APP_CLOUDINARY_UNSIGNED_URL,
        formData,
      );
      thumbnailDetails = response?.data;
    }


    const response = await createBlogService(token)({
      ...params,
      thumbnailId: thumbnailDetails?.public_id,
      thumbnail: thumbnailDetails?.secure_url,
    });
    dispatch({type: ADDING_BLOGS_SUCCESS, blog: response?.data})
    toast.success('Blog added successfully')
    return true
  } catch (error) {
    dispatch({type: ADDING_BLOGS_FAILED})
    toast.error('Add Blog Failed')
  }
}
